import { supabase } from '@/integrations/supabase/client';

/**
 * Inserts a waitlist signup. Silently ignores duplicate emails (23505).
 * Throws on any other error.
 */
export async function addWaitlistSignup(email: string, source: string): Promise<void> {
  const { error } = await supabase.from('waitlist_signups').insert({ email, source });
  if (error) {
    if (error.code === '23505') return;
    throw new Error(error.message);
  }
}

/**
 * Records an email opt-out. Throws on error.
 */
export async function addEmailOptout(email: string, reason?: string): Promise<void> {
  const { error } = await supabase
    .from('email_optouts')
    .insert({ email, ...(reason ? { reason } : {}) });
  if (error) {
    throw new Error(error.message);
  }
}
